import React, { useState, useEffect } from "react";

 function InnRadioButton(props) {
  const [rbValue, setrbValue] = useState(props.value);
  const [rbKey, setrbKey] = useState(props.value);

  const handlechange = (e) => {
    //setrbValue(e.target.value);
    setrbKey(e.target.id);
    if (props.onSelectionChange != undefined) {
      props.onSelectionChange(e.target.value, e.target.id);
    }
  };

  useEffect(() => {
    // setrbValue(props.value);
    if (props.value != undefined) {
      // console.log('props.value >>', props.value, props.data);
      setrbKey(props.value);
    }
  }, [props.value]);

  const content =
    props.data &&
    props.data.map((d) => {
      return (
        <div
          onChange={handlechange}
          className={
            props.position === "V" ? "d-block" : "d-inline-block mrgn-rt10"
          }
        >
          <label
            className={
              props.disabled == true ? "filter-check disabled" : "filter-check"
            }
          >
            <h5>{d.value}</h5>
            <input
              type="radio"
              className="custom-control-input"
              value={d.value}
              id={d.key}
              name={props.groupname}
              checked={rbKey == d.key}
              disabled={props.disabled}
            />
            <span className="radio-btn"></span>
          </label>
        </div>
      );
    });

  return (
    <div>
      {content}
      <div class="error">
        <span></span>
      </div>
    </div>
  );
}

export default InnRadioButton

